import { AddressDefinition } from './definitions/address';
import { CheckboxDefinition } from './definitions/checkbox';
import { DividerDefinition } from './definitions/divider';
import { EmailDefinition } from './definitions/email';
import { FileDefinition } from './definitions/file';
import { HeadingDefinition } from './definitions/heading';
import { ListDefinition } from './definitions/list';
import { NumberDefinition } from './definitions/number';
import { SelectDefinition } from './definitions/select';
import { TextDefinition } from './definitions/text';
import { TextAreaDefinition } from './definitions/textarea';
import type { BaseFieldSchema, FieldDefinition, FormFieldSchema } from './types';

class FieldRegistry {
  private definitions: Map<string, FieldDefinition<FormFieldSchema, unknown>> = new Map();

  constructor() {
    this.register(TextDefinition);
    this.register(TextAreaDefinition);
    this.register(NumberDefinition);
    this.register(CheckboxDefinition);
    this.register(SelectDefinition);
    this.register(EmailDefinition);
    this.register(AddressDefinition);
    this.register(FileDefinition);
    this.register(HeadingDefinition);
    this.register(DividerDefinition);
    this.register(ListDefinition);
  }

  register<TSchema extends BaseFieldSchema, TValue>(definition: FieldDefinition<TSchema, TValue>) {
    this.definitions.set(
      definition.type,
      definition as unknown as FieldDefinition<FormFieldSchema, unknown>
    );
  }

  get<TSchema extends BaseFieldSchema = FormFieldSchema, TValue = unknown>(
    type: string
  ): FieldDefinition<TSchema, TValue> | undefined {
    return this.definitions.get(type) as FieldDefinition<TSchema, TValue> | undefined;
  }

  getAll(): FieldDefinition<FormFieldSchema, unknown>[] {
    return Array.from(this.definitions.values());
  }

  getByCategory(category: string): FieldDefinition<FormFieldSchema, unknown>[] {
    return this.getAll().filter((def) => def.category === category);
  }
}

export const fieldRegistry = new FieldRegistry();
